import { Button, ButtonText, HStack, Icon } from "wealthmode-frontend/gluestack/ui"
import { RefreshCwIcon } from "wealthmode-frontend/icons"

/** Pagination and refresh controls; prev/next render only when available. */
export function TableCardPagination({
  showPrev,
  showNext,
  onPrev,
  onNext,
  onRefresh,
  refreshDisabled,
}: {
  showPrev: boolean
  showNext: boolean
  onPrev: () => void
  onNext: () => void
  onRefresh?: () => void
  refreshDisabled?: boolean
}) {
  return (
    <HStack className="gap-2 items-center shrink-0">
      {onRefresh ? (
        <Button
          size="sm"
          variant="outline"
          action="secondary"
          onPress={refreshDisabled ? undefined : onRefresh}
          disabled={refreshDisabled}
          accessibilityLabel="Refresh"
        >
          <Icon
            as={RefreshCwIcon}
            className="text-foreground-secondary h-8 w-8"
          />
        </Button>
      ) : null}
      {showPrev ? (
        <Button
          size="sm"
          variant="outline"
          action="secondary"
          onPress={onPrev}
        >
          <ButtonText>«</ButtonText>
        </Button>
      ) : null}
      {showNext ? (
        <Button
          size="sm"
          variant="outline"
          action="secondary"
          onPress={onNext}
        >
          <ButtonText>»</ButtonText>
        </Button>
      ) : null}
    </HStack>
  )
}
